export type SupportedLang = 'en' | 'fr' | 'da' | 'de';

export const SUPPORTED_LANGS: SupportedLang[] = ['en', 'fr', 'da', 'de'];

export const SITE_NAME = 'AllChinaBuy Spreadsheet Research Hub';

/**
 * Real site origin comes from the environment variable VITE_SITE_URL.
 * Fall back to the current origin at runtime only when it is not set.
 */
export const SITE_URL: string =
  (typeof import.meta.env !== 'undefined' &&
    (import.meta.env.VITE_SITE_URL as string | undefined)) ||
  (typeof window !== 'undefined' ? window.location.origin : '');

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png';

export const HOME_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20flatlay%20with%20sneakers%20hoodies%20tshirts%20accessories%20on%20warm%20beige%20background%20soft%20natural%20light%20editorial%20product%20photography%20clean%20aesthetic%20high%20detail&width=1600&height=900&seq=hero-bg-01&orientation=landscape';

export const ARTICLE_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=Flatlay%20of%20fashion%20products%20sneakers%20hoodie%20tshirt%20bag%20belt%20on%20warm%20neutral%20linen%20background%20soft%20natural%20light%20editorial%20clean%20aesthetic%20high%20detail&width=1000&height=600&seq=article-categories-01&orientation=landscape';

export interface SeoData {
  title: string;
  description: string;
  keywords: string;
  locale: string;
}

export const HOME_SEO: Record<SupportedLang, SeoData> = {
  en: {
    title: 'AllChinaBuy Spreadsheet — Product Research Hub',
    description:
      'Explore the AllChinaBuy spreadsheet, product research guides, seller resources, QC tips, shipping information and the latest buying resources — all organized in one place.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy review, AllChinaBuy shipping, AllChinaBuy coupon, AllChinaBuy warehouse, product research',
    locale: 'en_US',
  },
  fr: {
    title: 'AllChinaBuy Spreadsheet — Centre de Recherche Produits',
    description:
      'Découvrez le spreadsheet AllChinaBuy, les guides de recherche produits, les ressources vendeurs, les conseils QC, les informations d\u2019expédition et les dernières ressources d\u2019achat.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy avis, AllChinaBuy livraison, AllChinaBuy coupon, recherche produits',
    locale: 'fr_FR',
  },
  da: {
    title: 'AllChinaBuy Spreadsheet — Produktforskningshub',
    description:
      'Udforsk AllChinaBuy-regnearket, produktforskningsguider, sælgerressourcer, QC-tips, forsendelsesoplysninger og de nyeste købsressourcer — alt samlet ét sted.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy anmeldelse, AllChinaBuy forsendelse, AllChinaBuy rabatkode, produktforskning',
    locale: 'da_DK',
  },
  de: {
    title: 'AllChinaBuy Spreadsheet — Produkt-Recherche-Hub',
    description:
      'Entdecken Sie das AllChinaBuy-Spreadsheet, Produkt-Recherche-Anleitungen, Verkäufer-Ressourcen, QC-Tipps, Versandinformationen und die neuesten Kauf-Ressourcen — alles an einem Ort.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy Bewertung, AllChinaBuy Versand, AllChinaBuy Gutschein, Produktrecherche',
    locale: 'de_DE',
  },
};

export const ARTICLE_SEO: Record<SupportedLang, SeoData> = {
  en: {
    title: 'AllChinaBuy Spreadsheet: Complete Product & Buying Guide',
    description:
      'A complete guide to the AllChinaBuy spreadsheet: product research, seller verification, quality control, shipping and warehouse information with practical buying tips.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy buying guide, AllChinaBuy product research, AllChinaBuy QC, AllChinaBuy shipping',
    locale: 'en_US',
  },
  fr: {
    title: 'AllChinaBuy Spreadsheet : Guide d\u2019Achat et de Produits Complet',
    description:
      'Un guide complet du spreadsheet AllChinaBuy : recherche de produits, vérification des vendeurs, contrôle qualité, expédition et informations d\u2019entrepôt avec conseils pratiques.',
    keywords:
      'AllChinaBuy Spreadsheet, guide d\u2019achat AllChinaBuy, recherche produits, contrôle qualité, expédition',
    locale: 'fr_FR',
  },
  da: {
    title: 'AllChinaBuy Spreadsheet: Komplet Produkt- og Købsguide',
    description:
      'En komplet guide til AllChinaBuy-regnearket: produktforskning, sælgerverifikation, kvalitetskontrol, forsendelse og lageroplysninger med praktiske købstips.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy købsguide, produktforskning, kvalitetskontrol, forsendelse',
    locale: 'da_DK',
  },
  de: {
    title: 'AllChinaBuy Spreadsheet: Kompletter Produkt- und Kaufratgeber',
    description:
      'Ein vollständiger Leitfaden zum AllChinaBuy-Spreadsheet: Produktrecherche, Verkäuferprüfung, Qualitätskontrolle, Versand und Lagerinformationen mit praktischen Tipps.',
    keywords:
      'AllChinaBuy Spreadsheet, AllChinaBuy Kaufratgeber, Produktrecherche, Qualitätskontrolle, Versand',
    locale: 'de_DE',
  },
};